import { render } from "./auto-renew-config-info-office.vue?vue&type=template&id=bc9bdb3a&ts=true"
import script from "./auto-renew-config-info-office.vue?vue&type=script&lang=ts"
export * from "./auto-renew-config-info-office.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__